// start:ng42.barrel
import './corporate-contact-editor-popup.component';
import './corporate-contact-editor.component';
import './corporate-contact-list.component';
import './corporate-contact-picker-field.component';
// end:ng42.barrel

